module.exports = __webpack_public_path__ + "static/media/18.e3ef3913.wav";